<template>
	<b-card>
		<div class="hidden-print">
			<b-row style="margin-top: 10px; margin-bottom: 10px">
				<b-col cols="3">
					<b-form-select v-model="departmentId" name="departmentId" :disabled="depDisabled">
						<option v-for="(selectOption, indexOpt) in departments" :key="indexOpt" :value="selectOption.id">{{ selectOption.name }}</option>
						<template slot="first">
							<option :value="null" disabled>
								-- {{ $t('priceControl.departments') }} --
							</option>
						</template>
					</b-form-select>
				</b-col>
				<b-col cols="2">
					<date-picker v-model="fromDate" lang="ru" style="width: 100%" :placeholder="$t('certificate.fromDate')" valueType="format" format="DD-MM-YYYY"/>
				</b-col>
				<b-col cols="2">
					<date-picker v-model="toDate" lang="ru" style="width: 100%" :placeholder="$t('certificate.toDate')" value-type="format" format="DD-MM-YYYY"/>
				</b-col>
				<b-col>
					<b-form-input v-model="itemName" :placeholder="$t('goods.name')"/>
				</b-col>
				<b-col cols="2">
					<b-button @click="getItems" variant="dark" class="fa fa-search mr-3"/>
					<b-button @click="print" variant="outline-dark" class="fa fa-print"/>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="2">
					<b-checkbox v-model="allDeps" switch>
						{{$t("Whole_firm")}}
					</b-checkbox>
				</b-col>
				<b-col cols="3">
					<b-form-group breakpoint="lg" label-size="sm" label-cols="4" label="Тип документа" label-for="refName" class="required" size="sm">
						<b-form-select v-model="documentType" value="id" value-field="id" text-field="name" label-field="name" size="sm" :options="docTypes" name="documentType"/>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<multiselect
						label="name"
						track-by="id"
						v-model="group"
						:multiple="true"
						:options="groups"
						:allow-empty="true"
						:group-select="true"
						:show-labels="false"
						class="multiselect-pricing"
						:placeholder="$t('goods.create.select-group')"
					/>
				</b-col>
				<b-col>
					<multiselect
						label="name"
						track-by="id"
						:multiple="true"
						v-model="category"
						:allow-empty="true"
						:group-select="true"
						:show-labels="false"
						:options="categorys"
						class="multiselect-pricing"
						:placeholder="$t('goods.create.category')"
					/>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<multiselect
						label="name"
						track-by="id"
						v-model="group1"
						:multiple="true"
						:options="groups"
						:allow-empty="true"
						:group-select="true"
						:show-labels="false"
						id="danger-multiselect"
						:placeholder="$t('Except_group')"
						class="multiselect-pricing danger-multiselect"
					/>
				</b-col>
				<b-col>
					<multiselect
						label="name"
						track-by="id"
						:multiple="true"
						v-model="category1"
						:allow-empty="true"
						:group-select="true"
						:show-labels="false"
						:options="categorys1"
						class="multiselect-pricing danger-multiselect"
						:placeholder="$t('Except_category')"
					/>
				</b-col>
			</b-row>
			<hr class="mt-4">
		</div>
		<b-card-body>
			<b-row>
				<b-col cols="3">
					<div style="font-size: 12px"><b>DutyFree International</b></div>
				</b-col>
				<b-col cols="6" class="text-center">
					<h6><b>{{$t("Write_off_for_the_period")}} {{$t("c")}} {{ fromDate ? fromDate : '________' }} {{$t("po")}} {{ toDate ? toDate : '________' }}</b></h6>
				</b-col>
				<b-col class="text-right"></b-col>
			</b-row>
			<b-row>
				<b-col>
					<b style="font-size: 12px">{{ $t('pricing.department') }}: {{ departmentId ? depName : '__________________' }}</b>
				</b-col>
			</b-row>
			<b-row class="mt-5 mb-4">
				<b-col>
					<table class="b-table table-hover table-bordered" style="font-size: 11px; width: 100%">
						<thead>
						<tr>
							<th class="text-center" style="font-size: 10px; width: 3%">№</th>
							<th class="text-center" style="font-size: 10px; width: 10%">{{$t("SpecialCode")}}</th>
							<th class="text-center" style="font-size: 10px; width: 20%">{{$t("name")}}</th>
							<th class="text-center" style="font-size: 10px; width: 10%">{{$t("кол-во")}}</th>
							<th class="text-center" style="font-size: 10px; width: 10%">{{$t("Income_amount")}}</th>
							<th class="text-center" style="font-size: 10px; width: 10%">{{$t("Prod_Amount")}}</th>
							<th class="text-center" style="font-size: 10px; width: 10%">{{$t("Wig_in_soums")}}</th>
							<th class="text-center" style="font-size: 10px; width: 10%">{{$t("Prod_in_soums")}}</th>
						</tr>
						</thead>
						<tbody v-for="(item, index) in items" :key="`items-${index}`" style="padding: 0; margin: 0">
						<tr class="text-left">
							<td colspan="8"><b>{{$t("customer")}}: </b>{{ item.groupName }}</td>
						</tr>
						<tr class="text-center" v-for="(sub, i) in item.subGroups" :key="`child-${i}`" style="padding: 0; margin: 0">
							<td colspan="8">
								<b>{{$t("subGroup")}}: </b><i>{{ sub.supGroupName }}</i>
								<table class="b-table table-striped table-hover table-bordered" style="width: 100%; padding: 0; margin: 0">
									<tr v-for="(tmp, ind) in sub.whDocumentItems" :key="`whDocumentItems-${i}`">
										<td class="text-center" style="font-size: 10px; width: 3%">{{ ind+1 }}</td>
										<td class="text-center" style="font-size: 10px; width: 10%">{{ tmp.barcode }}</td>
										<td class="text-left" style="font-size: 10px; width: 20%">{{ tmp.itemName }}</td>
										<td class="text-center" style="font-size: 10px; width: 10%">{{ tmp.count }}</td>
										<td class="text-center" style="font-size: 10px; width: 10%">{{ (tmp.count*tmp.incomePrice) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</td>
										<td class="text-center" style="font-size: 10px; width: 10%">{{ (tmp.count*tmp.price) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</td>
										<td class="text-center" style="font-size: 10px; width: 10%">{{ (tmp.count*tmp.incomePriceUzs) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</td>
										<td class="text-center" style="font-size: 10px; width: 10%">{{ (tmp.count*tmp.priceUzs) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</td>
									</tr>
									<tr>
										<td colspan="3" class="text-right"><b>Итого: </b></td>
										<td class="text-center"><b>{{ sumRemaining(sub) }}</b></td>
										<td class="text-center"><b>{{ sumIncomePrice(sub) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
										<td class="text-center"><b>{{ sumPrice(sub) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
										<td class="text-center"><b>{{ sumIncomePriceUzs(sub) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
										<td class="text-center"><b>{{ sumPriceUzs(sub) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
									</tr>
								</table>
							</td>
						</tr>
						<tr>
							<td colspan="3" class="text-right"><b>{{$t("Total_for")}} {{ item.groupName }}:</b></td>
							<td class="text-center"><b>{{ itogoSumRemaining(item) ? itogoSumRemaining(item) : 0 }}</b></td>
							<td class="text-center"><b>{{ itogoSumIncomePrice(item) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
							<td class="text-center"><b>{{ itogoSumPrice(item) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
							<td class="text-center"><b>{{ itogoSumIncomePriceUzs(item) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
							<td class="text-center"><b>{{ itogoSumPriceUzs(item) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
						</tr>
						</tbody>
						<tr v-if="items.length > 0">
							<td colspan="3" class="text-right"><b>{{$t("total")}}:</b></td>
							<td class="text-center"><b>{{ vsegoRemaining(items) ? vsegoRemaining(items) : 0 }}</b></td>
							<td class="text-center"><b>{{ vsegoIncomePrice(items) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
							<td class="text-center"><b>{{ vsegoPrice(items) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
							<td class="text-center"><b>{{ vsegoIncomePriceUzs(items) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
							<td class="text-center"><b>{{ vsegoPriceUzs(items) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
						</tr>
						<tr v-if="loading">
							<td colspan="8" class="text-center">
								<b-spinner small class="mr-2"/><strong>Loading...</strong>
							</td>
						</tr>
					</table>
				</b-col>
			</b-row>
		</b-card-body>
	</b-card>
</template>

<script>
import UsersService from "../../../services/users.sevice";
import {TokenService} from "../../../services/storage.service";
import ReportService from "./report.service";
import Multiselect from "vue-multiselect";
import ReferencesService from "../../../services/references.sevice";

export default {
	name: "Списание за период",
	components: {Multiselect},
	data() {
		return {
			items: [],
			departments: [],
			departmentId: null,
			fromDate: null,
			toDate: null,
			depDisabled: false,
			loading: false,
			allDeps: false,
			itemName: '',
			group: null,
			group1: null,
			category: null,
			category1: null,
			groups: [],
			categorys: [],
			categorys1: [],
			groupIds: [],
			groupNots: [],
			categoryIds: [],
			subGroupNots: [],
			docTypes: [
				{id: 'PROTOKOL', name: 'Акт'},
				{id: 'PROTOKOL_EKSPERTIZA', name: 'Акт на экспертизу'}
			],
			documentType: null
		}
	},
	computed: {
		depName() {
			this.departments.forEach(dep => {
				if (dep.id === this.departmentId) {
					this.departmentName = dep.name
				}
			})
			return this.departmentName
		}
	},
	watch: {
		allDeps: {
			handler(e) {
				if (e) {
					this.departmentId = null
					this.depDisabled = true
				} else {
					this.depDisabled = false
				}
			}
		},
		'group': {
			handler(g) {
				this.groupIds = []
				g.filter(t => this.groupIds.push(t.id))
				if (this.groupIds.length > 0) {
					ReferencesService.getCategorysByGroupIds(this.groupIds).then(res => {
						this.categorys = res.data
					})
				} else {
					this.categorys = []
				}
				this.category = null
			}
		},
		'category': {
			handler(c) {
				this.categoryIds = []
				c.filter(t => this.categoryIds.push(t.id))
			}
		},
		'group1': {
			handler(g) {
				this.groupNots = []
				g.filter(t => this.groupNots.push(t.id))
				if (this.groupNots.length > 0) {
					ReferencesService.getCategorysByGroupIds(this.groupNots).then(res => {
						this.categorys1 = res.data
					})
				} else {
					this.categorys1 = []
				}
				this.category1 = null
			}
		},
		'category1': {
			handler(c) {
				this.subGroupNots = []
				c.filter(t => this.subGroupNots.push(t.id))
			}
		}
	},
	methods: {
		print() {
			window.print();
		},
		async getDeps() {
			await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
				this.departments = response.data.permittedDepartments
			})
		},
		getItems() {
			this.loading = true
			if ((this.departmentId || this.allDeps) && this.fromDate && this.toDate) {
				let data = {
					startDate: this.fromDate,
					endDate: this.toDate,
					deps: this.departmentId,
					allDeps: this.allDeps,
					groups: this.groupIds,
					subGroups: this.categoryIds,
					groupNots: this.groupNots,
					subGroupNots: this.subGroupNots,
					documentType: this.documentType,
					value: this.itemName
				}
				ReportService.getReportItems6(data).then(res => {
					this.items = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.loading = false
				this.$vs.notify({
					text: "Выберите Подразделение с периодом",
					color: "warning",
					icon: "close",
					position: "top-right"
				});
				return 0;
			}
		},
		sumRemaining(item) {
			let sum = 0
			item.whDocumentItems.forEach(tmp => {
				sum+=tmp.count
			})
			return sum
		},
		sumIncomePrice(item) {
			let sum = 0
			item.whDocumentItems.forEach(tmp => {
				sum+=(tmp.count*tmp.incomePrice.toFixed(2))
			})
			return sum
		},
		sumPrice(item) {
			let sum = 0
			item.whDocumentItems.forEach(tmp => {
				sum+=(tmp.count*tmp.price.toFixed(2))
			})
			return sum
		},
		sumIncomePriceUzs(item) {
			let sum = 0
			item.whDocumentItems.forEach(tmp => {
				sum+=(tmp.count*tmp.incomePriceUzs.toFixed(2))
			})
			return sum
		},
		sumPriceUzs(item) {
			let sum = 0
			item.whDocumentItems.forEach(tmp => {
				sum+=(tmp.count*tmp.priceUzs.toFixed(2))
			})
			return sum
		},
		itogoSumRemaining(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.whDocumentItems.forEach(t => {
					sum+=t.count
				})
				itog+=sum
			})
			return itog
		},
		itogoSumIncomePrice(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.whDocumentItems.forEach(t => {
					sum+=(t.count*t.incomePrice.toFixed(2))
				})
				itog+=sum
			})
			return itog
		},
		itogoSumPrice(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.whDocumentItems.forEach(t => {
					sum+=(t.count*t.price.toFixed(2))
				})
				itog+=sum
			})
			return itog
		},
		itogoSumIncomePriceUzs(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.whDocumentItems.forEach(t => {
					sum+=(t.count*t.incomePriceUzs.toFixed(2))
				})
				itog+=sum
			})
			return itog
		},
		itogoSumPriceUzs(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.whDocumentItems.forEach(t => {
					sum+=(t.count*t.priceUzs.toFixed(2))
				})
				itog+=sum
			})
			return itog
		},
		vsegoRemaining(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.whDocumentItems.forEach(t => {
						sum+=t.count
					})
					itog+=sum
				})
				vsego+=itog
			})
			return vsego
		},
		vsegoIncomePrice(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.whDocumentItems.forEach(t => {
						sum+=(t.count*t.incomePrice.toFixed(2))
					})
					itog+=sum
				})
				vsego+=itog
			})
			return vsego
		},
		vsegoPrice(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.whDocumentItems.forEach(t => {
						sum+=(t.count*t.price.toFixed(2))
					})
					itog+=sum
				})
				vsego+=itog
			})
			return vsego
		},
		vsegoIncomePriceUzs(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.whDocumentItems.forEach(t => {
						sum+=(t.count*t.incomePriceUzs.toFixed(2))
					})
					itog+=sum
				})
				vsego+=itog
			})
			return vsego
		},
		vsegoPriceUzs(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.whDocumentItems.forEach(t => {
						sum+=(t.count*t.priceUzs.toFixed(2))
					})
					itog+=sum
				})
				vsego+=itog
			})
			return vsego
		}
	},
	created() {
		ReferencesService.getSubReferenceChildren(14).then(res => {
			this.groups = res.data
		})
		this.getDeps();
	}
}
</script>

<style scoped lang="scss">

@page {
	margin: 1cm;
}

@media print {
	.hidden-print {
		display: none;
	}
	.nav {
		display: none;
	}
	.nav-pills {
		display: none;
	}
	.flex-column {
		display: none;
	}
	.footer{
		margin-bottom: 25px;
	}
}

</style>
